import { FunctionComponent } from 'react'
import classNames from 'classnames'
import { IconButton } from '../../shared'
import { MessageBubbleProps } from './MessageBubble.model'
import styles from './MessageBubble.module.scss'

export const MessageBubble: FunctionComponent<MessageBubbleProps> = ({
  message,
  progressText,
  showEdit = false,
  showRetry = false,
  showStop = false,
  onEdit,
  onRetry,
  onStop,
}) => {
  if (progressText) {
    return (
      <div className={classNames(styles.bubble, styles.assistant)}>
        <div className={styles.progressRow}>
          <div className={styles.progress}>
            <span className={styles.progressDot} />
            {progressText}
          </div>
          {showStop && (
            <IconButton
              icon="stop"
              theme="transparent-dark"
              size="nano"
              noBorder
              title="Arrêter l’analyse"
              onClick={onStop}
              testId="button-stats_assistant-progress-stop"
            />
          )}
        </div>
      </div>
    )
  }

  if (message?.type !== 'text' || message.role !== 'user') return null

  return (
    <div className={classNames(styles.bubble, styles.user)}>
      <div className={styles.textContent}>{message.content.text}</div>
      {(showEdit || showRetry) && (
        <div className={styles.actions}>
          {showEdit && (
            <IconButton
              icon="pencil"
              theme="transparent-dark"
              size="nano"
              noBorder
              title="Modifier le message"
              onClick={onEdit}
              testId="button-stats_assistant-message-edit"
            />
          )}
          {showRetry && (
            <IconButton
              icon="reload"
              theme="transparent-dark"
              size="nano"
              noBorder
              title="Renvoyer le message"
              onClick={onRetry}
              testId="button-stats_assistant-message-retry"
            />
          )}
        </div>
      )}
    </div>
  )
}
